import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import {
  faRightFromBracket,
  IconDefinition,
} from '@fortawesome/pro-solid-svg-icons';
import {
  ButtonComponent,
  ContentComponent,
  SingleCardLayoutComponent,
} from '@lyceo/shared/ui';
import { AuthFacade } from '@lyceo/shared/auth/data-access';

@Component({
  selector: 'homi-plan-page',
  imports: [
    SingleCardLayoutComponent,
    FontAwesomeModule,
    ContentComponent,
    ButtonComponent,
  ],
  templateUrl: './no-access-page.component.html',
  styleUrl: './no-access-page.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class NoAccessPageComponent {
  private readonly authFacade: AuthFacade = inject(AuthFacade);

  public readonly faRightFromBracket: IconDefinition = faRightFromBracket;

  public logout(): void {
    this.authFacade.userLogout();
  }
}
